module.exports = __webpack_public_path__ + "static/media/drivewell-assistant.9dd551dc.png";